import request from '@/router/axios'

//后端  基础费率列表
export function getBasicFeeList(query) {
	return request({
		url: '/dist/settle/ruleBasic/page',
		method: 'get',
		params: query,
	})
}

//后端 奖励费率列表
export function getAwardFeeList(query) {
	return request({
		url: '/dist/settle/ruleAward/page',
		method: 'get',
		params: query,
	})
}

//后端 审核接口！！！！  1:'初审' 2: '复审' 3: '提交财务' 4：'打款'
//CREATED待处理，CANCELED已撤销，REJECTED_FIRST初审驳回，
// APPROVED_FIRST上级复审，REJECTED_FINAL复审驳回，
// APPROVED_FINAL复审通过，COMMITTED_FINANCE提交财务处理，REMITTED已打款
// /settle/apply/changeItemFee 修改结算费用
export function applyApi(type, data) {
	return request({
		url: `/dist/settle/apply/${type}`,
		method: 'put',
		data,
	})
}

//基础结算规则新增post /  修改put
export function addOrEditRateBasic(method, data) {
	return request({
		url: '/dist/settle/ruleBasic',
		method,
		data,
	})
}

//基础结算规则修改
export function basicFeeEdit(data) {
	return request({
		url: '/dist/settle/settleRuleBasic',
		method: 'put',
		data,
	})
}

//渠道数据 区分基础和奖励
export function getChannels(reqType, query) {
	return request({
		url: `/dist/settle/${reqType}/channels`,
		method: 'get',
		params: query,
	})
}

//奖励规则新增post /修改put
export function addOrEditRateAward(method, data) {
	return request({
		url: '/dist/settle/ruleAward',
		method,
		data,
	})
}

//基础费率 通过ID 获取详情
export function getBasicFeeById(id) {
	return request({
		url: `/dist/settle/ruleBasic/${id}`,
		method: 'get',
	})
}

//奖励方案通过ID 获取详情
export function getAwardFeeById(id) {
	return request({
		url: `/dist/settle/ruleAward/${id}`,
		method: 'get',
	})
}

//基础费率 删除
export function delBasicFee(id) {
	return request({
		url: `/dist/settle/ruleBasic/${id}`,
		method: 'delete',
	})
}

//奖励规则 删除
export function delAwardFee(id) {
	return request({
		url: `/dist/settle/ruleAward/${id}`,
		method: 'delete',
	})
}

//申请----结算保单管理- 普通结算
export function getSettlementOrdersBasic(query) {
	return request({
		url: `/dist/settle/order/list`,
		method: 'get',
		params: query,
	})
}

//申请----结算保单管理- 奖励结算 /settle/ruleAward/list
export function getSettlementOrdersAward(query) {
	return request({
		url: `/dist/settle/award/list`,
		method: 'get',
		params: query,
	})
}

export function getSettlementRuleAwardList() {
	return request({
		url: `/dist/settle/ruleAward/list`,
		method: 'get',
	})
}

export function getSettlementRuleBasicList() {
	return request({
		url: `/dist/settle/ruleBasic/list`,
		method: 'get',
	})
}

//前端提交申请
export function commitSettleApply(obj) {
	return request({
		url: '/dist/settle/apply',
		method: 'post',
		data: obj,
	})
}

//前端通过iD查询
export function getSettleApplyById(id) {
	return request({
		url: `/dist/settle/apply/${id}`,
		method: 'get',
	})
}

//前端 撤销
export function cancelSettleApply(id) {
	return request({
		url: `/dist/settle/apply/cancel/${id}`,
		method: 'put',
	})
}

//前端 结算管理列表
export function getSettleApplyList(params) {
	return request({
		url: `/dist/settle/apply/page`,
		method: 'get',
		params,
	})
}

//前端 结算管理明细 -- 普通
export function getSettleApplyDetail(params) {
	let tempId = params.id
	params.id = undefined
	return request({
		url: `/dist/settle/apply/orderList/${tempId}`,
		method: 'get',
		params,
	})
}

//前端 结算管理明细 -- 普通分页
export function getSettleApplyDetailPage(params) {
	let tempId = params.id
	params.id = undefined
	return request({
		url: `/dist/settle/apply/orderPage/${tempId}`,
		method: 'get',
		params,
	})
}

//前端 结算管理明细 -- 奖励
export function getSettleApplyDetailAward(params) {
	let tempId = params.id
	params.id = undefined
	return request({
		url: `/dist/settle/apply/awardList/${tempId}`,
		method: 'get',
		params,
	})
}

//异常保单信息变更
export function getChangeFeeList(params) {
	return request({
		url: '/dist/settle/order/page',
		method: 'get',
		params,
	})
}

//未结算保单
export function getNoApplyList(params) {
	return request({
		url: '/dist/settle/order/page',
		method: 'get',
		params,
	})
}

//异常保单信息变更 核算
export function setChangeFeeCalc(params) {
	return request({
		url: '/dist/settle/order/calc',
		method: 'put',
		data: params,
	})
}

//结算渠道信息管理
export function getMyChannelSettleInfo() {
	return request({
		url: '/dist/distChannel/my',
		method: 'get',
	})
}

//结算渠道信息管理
export function editMyChannelSettleInfo(reqData) {
	return request({
		url: '/dist/distChannel/my',
		method: 'put',
		data: reqData,
	})
}

//奖励结算 已结算和未结算
export function getAwardList(params) {
	return request({
		url: `/dist/settle/award/page`,
		method: 'get',
		params,
	})
}

//生成结算计划
export function createSettlePlan() {
	return request({
		url: `/dist/settle/plan/generate`,
		method: 'put',
	})
}

//列表/settle/plan/page
export function getSettlePlanList(params = {}) {
	return request({
		url: `/dist/settle/plan/page`,
		params,
	})
}

//预警
export function getSettleAlertsList(params = {}) {
	return request({
		url: `/dist/settle/plan/alerts`,
		params,
	})
}

//预警刷新 /settle/plan/alerts
export function refreshSettleAlerts() {
	return request({
		url: `/dist/settle/plan/alerts`,
		method: 'put',
	})
}

//结算删除
export function deleteSettlePlan(id) {
	return request({
		url: `/dist/settle/order/cancel?id=${id}`,
		method: 'put',
	})
}

//奖励结算阈值提醒
export function getAwardProgress() {
	return request({
		url: `/dist/settle/ruleAward/progress`,
		method: 'get',
	})
}

//导入结算计划
export function importSettlePlan(queryData) {
	let {data, url} = queryData
	return request({
		url,
		method: 'post',
		data,
	})
}

//GET /distChannel/checkSettleAlert 查询结算预警，每天第一次登录系统时查询
export function getCheckSettleAlert() {
	return request({
		url: `/dist/distChannel/checkSettleAlert`,
	})
}
